import { css } from 'styled-components'

export default (fill) => css`
  & svg {
    & path {
      fill: ${fill};
    }
  }
`
